import { useAccount } from '@bnnvara/accounts';
import { useBrand } from '@bnnvara/brand';
import { useContext } from 'react';

import ComposableContext from '../ComposableContext';
import createPageElements from '../helpers/createPageElements';

const useComposablePage = () => {
  const brand = useBrand();
  const account = useAccount();

  const composableContextValue = useContext(ComposableContext);
  /**
   * `ComposableContext` provides these the data that is received
   * from the GraphQL query and a helper function that determines
   * wheter or not the page is found.
   */
  const { data, isFound } = composableContextValue;

  function getJson(normal, fallback, error) {
    if (!isFound(data)) {
      return error;
    }

    const isMember = account?.profile?.relation_number;
    const requiresMembership =
      data?.brand?.article?.requiresMembership === true;

    if (!isMember && requiresMembership) {
      return fallback;
    }

    return normal;
  }

  /**
   * Define a `render` function that can be used by the component.
   *
   * @param json        object   An object containing the page meta and elements.
   * @param  errorJson  object   An object containing the page meta and elements for the error page.
   * @param isRoot      boolean  Whether or not it's the root of the page.
   */
  const render = (json, errorJson, isRoot = true, fallbackJson = null) => {
    const file = getJson(
      json,
      fallbackJson !== null ? fallbackJson : errorJson,
      errorJson
    );

    return createPageElements(file, composableContextValue, brand, isRoot);
  };

  return {
    data,
    render,
  };
};

export default useComposablePage;
